import { CheckOutlined } from '@ant-design/icons';
import { Col, List, Row, Typography } from 'antd';
import { motion } from 'framer-motion';
const { Title, Paragraph, Text } = Typography;

const VMCBenefits = () => {
  return (
    <>
      <Row justify="center">
        <Col span={24} style={{ textAlign: 'center' }}>
          <motion.h2
            className="display-2 color-neutral-100"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            How Mark Certificates and DMARC{' '}
            <span className="text-no-wrap">Benefit Your Entire Organization</span>
          </motion.h2>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={{ span: 24 }} md={{ span: 12 }}>
          <motion.h3
            className="display-3 color-neutral-100"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Boost Marketing with Mark Certificates
          </motion.h3>
          <List
            dataSource={[
              'Display your authentic logo in emails, grabbing attention before clients even open them.',
              'Deliver a consistent, trustworthy brand experience across all email communications.',
              'Stand out in crowded inboxes, showing clients your commitment to security and quality.',
              'Increase engagement by over 10%, as shown by Verizon Media research.',
            ]}
            renderItem={(item, index) => (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
              >
                <List.Item
                  style={{
                    color: 'white',
                    fontSize: '1.4rem',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    padding: '8px 0',
                    lineHeight: '1.2',
                  }}
                >
                  <CheckOutlined
                    style={{
                      color: 'white',
                      fontSize: '1.4rem',
                      marginRight: '12px',
                      marginTop: '4px',
                      flexShrink: 0,
                      color: 'var(--blue-accent, #13D5FF)',
                      fontWeight: 'bold',
                    }}
                  />
                  <div style={{ flex: 1 }}>{item}</div>
                </List.Item>
              </motion.div>
            )}
          />
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.7 }}
          >
            <Paragraph>
              <Link
                href="https://www.digicert.com/content/dam/digicert/pdfs/guide/vmc-marketing-guide-en.pdf"
                className="btn-secondary white w-button"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Unlock Insights with Our VMC Marketing Primer <ExportOutlined />
              </Link>
            </Paragraph>
          </motion.div> */}
        </Col>

        <Col xs={{ span: 24 }} md={{ span: 12 }}>
          <motion.h3
            className="display-3 color-neutral-100"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Strengthen IT Security with DMARC
          </motion.h3>
          <List
            dataSource={[
              'Show your commitment to email security with DMARC best practices.',
              'Protect clients from spoofing and scams by blocking malicious emails.',
              'Monitor and control all emails sent from your domain.',
              'Identify and track threats targeting your domain in real-time.',
              'Combine DMARC with Mark Certificates to ensure authentic emails always reach their destination.',
            ]}
            renderItem={(item, index) => (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
              >
                <List.Item
                  style={{
                    color: 'white',
                    fontSize: '1.4rem',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    padding: '8px 0',
                    lineHeight: '1.2',
                  }}
                >
                  <CheckOutlined
                    style={{
                      fontSize: '1.4rem',
                      marginRight: '12px',
                      marginTop: '4px',
                      flexShrink: 0,
                      color: 'var(--blue-accent, #13D5FF)',
                      fontWeight: 'bold',
                    }}
                  />
                  <div style={{ flex: 1 }}>{item}</div>
                </List.Item>
              </motion.div>
            )}
          />
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.7 }}
          >
            <Paragraph>
              <Link
                href="https://www.digicert.com/content/dam/digicert/pdfs/guide/how-to-setup-dmarc-guide-en.pdf"
                className="btn-secondary white w-button"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Implementing DMARC in Your Organization <ExportOutlined />
              </Link>
            </Paragraph>
          </motion.div> */}
        </Col>
      </Row>
    </>
  );
};

export default VMCBenefits;
